import { render } from "./CardLoader.vue?vue&type=template&id=4f4894fb&scoped=true"
const script = {}

import "./CardLoader.vue?vue&type=style&index=0&id=4f4894fb&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f4894fb"]])

export default __exports__